<script>
import AdminLayout from '@layouts/admin-main'
import FinanceNav from '@components/admin/finance-nav'
import FinanceFundList from '@components/admin/finance-fund-list'

export default {
  page: {
    title: 'Admin::FinanceFundList',
    meta: [{ name: 'description', content: 'Admin::FinanceFundList' }],
  },
  components: {
    AdminLayout,
    FinanceNav,
    FinanceFundList,
  },
}
</script>

<template>
  <AdminLayout>
    <FinanceNav></FinanceNav>
    <FinanceFundList></FinanceFundList>
  </AdminLayout>
</template>
